var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransferring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .transferring-st0{fill:#FFFFFF;stroke:currentColor;stroke-width:8.2257;stroke-miterlimit:10;}\r\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "transferring-st0",
    d: "M321,196H38.9c-8.6,0-15.5-6.9-15.5-15.5v0c0-8.6,6.9-15.5,15.5-15.5H321c8.6,0,15.5,6.9,15.5,15.5v0 C336.5,189.1,329.6,196,321,196z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferring);
export default __webpack_public_path__ + "static/media/transferring.761434fea82cb8b87065850f1fb9cf68.svg";
export { ForwardRef as ReactComponent };